"use client";

import { useTranslations } from "next-intl";
import { Star } from "lucide-react";

const REVIEWS_SECTION_ID = "product-reviews";
const SHOW_REVIEWS_EVENT = "pdp:showReviews";

interface ReviewSnippetProps {
	avgRating: number;
	count: number;
}

export function ReviewSnippet({ avgRating, count }: ReviewSnippetProps) {
	const t = useTranslations("reviews");
	const tTabs = useTranslations("pdpTabs");

	const handleViewAll = () => {
		document.getElementById(REVIEWS_SECTION_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });
		window.dispatchEvent(new CustomEvent(SHOW_REVIEWS_EVENT));
	};

	if (count === 0) {
		return null;
	}

	return (
		<button
			type="button"
			onClick={handleViewAll}
			className="group mt-1 flex items-center gap-1.5 text-left transition-colors hover:text-foreground"
			aria-label={tTabs("viewAllReviews")}
		>
			<Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
			<span className="text-sm font-medium tabular-nums">{avgRating.toFixed(1)}</span>
			<span className="text-sm text-muted-foreground">({t("countShort", { count })})</span>
		</button>
	);
}

export { REVIEWS_SECTION_ID, SHOW_REVIEWS_EVENT };
